<template>
  <AlertBase :type="props.type" :noIcon="props.noIcon">
    <div class="ml-3 flex-1">
      <h3 v-if="header" class="mb-2 text-sm font-medium" :class="headerClasses">
        {{ header }}
      </h3>
      <div class="text-sm" :class="contentClasses">
        <slot />
      </div>
      <div v-if="$slots.actions" class="mt-4">
        <div class="-mx-3 -my-1.5 flex">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </AlertBase>
</template>

<script setup>
import { computed } from 'vue'

import AlertBase from './AlertBase.vue'
import { getContentClasses } from './common'

const props = defineProps({
  header: String,
  type: {
    type: String,
    default: 'info',
  },
  noIcon: Boolean,
})

const headerClasses = computed(() => {
  return {
    success: 'text-green-800 dark:text-green-50',
    info: 'text-blue-800 dark:text-blue-50',
    error: 'text-red-800 dark:text-red-50',
    warning: 'text-yellow-800 dark:text-yellow-50',
  }[props.type]
})

const contentClasses = computed(() => {
  return getContentClasses(props.type)
})
</script>
